import { AUTH_PROVIDER, SESSION_STATUS } from '@/constants/auth';
import { SyntheticEvent, useEffect, useRef } from 'react';
import { useSession, signIn } from 'next-auth/react';
import { usePrivate } from '@/components/private';
import { useRouter } from 'next/navigation';
import { PUBLIC_ROUTES } from '@/configs/routes';
import { UserRoleName } from '@/lib/types';

export function useAdminGuard(path: string) {
  const { status } = useSession();
  const { userOrganisations } = usePrivate();
  const router = useRouter();
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const isAuthenticated = status === SESSION_STATUS.AUTHENTICATED;
  const isAdmin = userOrganisations?.some((x) =>
    x.roleNames?.some((r) => r === UserRoleName.Admin),
  );

  function handleClickLink(e?: SyntheticEvent) {
    e?.preventDefault();

    if (status === SESSION_STATUS.LOADING) {
      timeoutRef.current = setTimeout(handleClickLink, 100);
      return;
    }

    if (!isAuthenticated) {
      signIn(AUTH_PROVIDER);
      return;
    }

    if (!isAdmin) {
      router.push(PUBLIC_ROUTES.REGISTRY_LANDING);
      return;
    }

    router.push(path);
  }

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, []);

  return {
    isAuthenticated,
    isAuthLoading: status === SESSION_STATUS.LOADING,
    handleClickLink,
  };
}
